interface JsonLdProps {
  data: Record<string, unknown>;
}

// 在页面中注入与真实可见内容匹配的 Schema.org JSON-LD
export default function JsonLd({ data }: JsonLdProps) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}